import {
  Chip,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@material-ui/core'
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined'
import { GoPackage } from 'react-icons/go'

import {
  BusinessCenter,
  ChromeReaderMode,
  Dashboard,
  DynamicFeed,
  LockOpenOutlined,
  LockOutlined,
  People,
  SdCardOutlined
} from '@material-ui/icons'
import { FaLaptopMedical, FaTasks } from 'react-icons/fa'
import { useHistory } from 'react-router-dom'
import Ubox from 'src/components/ui/Ubox'
import { SynPerfis } from 'src/core/consts/synPerfis'
import { SynRoutes } from 'src/core/consts/synRoutes'
import useAtividade from 'src/hooks/useAtividade'
import useAuth from 'src/hooks/useAuth'
import config from 'src/config'
import { gerarAuthCode } from 'src/api/auth/index'
import AttachMoneyIcon from '@material-ui/icons/AttachMoney'

function menuLateral() {
  const { perfilAtual, user } = useAuth()
  const history = useHistory()
  const { obterQtdePendente } = useAtividade()

  return (
    <List>
      <Ubox render={perfilAtual === SynPerfis.AGENDAMENTO_HOSPITAL}>
        <ListItem
          button
          onClick={() => history.push(SynRoutes.listagemOrcamentosHospital)}
          id="submenus-solicitacoes"
        >
          <ListItemIcon>
            <AssignmentOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Solicitações" />
        </ListItem>

        <ListItem
          button
          onClick={() => history.push(SynRoutes.alterarSenha)}
          id="submenus-alterar-senha"
        >
          <ListItemIcon>
            <LockOutlined />
          </ListItemIcon>
          <ListItemText primary="Alterar senha" />
        </ListItem>
      </Ubox>

      <Ubox render={perfilAtual !== SynPerfis.AGENDAMENTO_HOSPITAL}>
        {!!user.verDashboard && (
          <ListItem
            button
            onClick={() => history.push(SynRoutes.dashboard)}
            id="submenus-dashboard"
          >
            <ListItemIcon>
              <Dashboard />
            </ListItemIcon>
            <ListItemText primary="Dashboard" />
          </ListItem>
        )}

        <ListItem
          button
          onClick={() => history.push(SynRoutes.listagemMedicos)}
          id="submenus-medicos"
        >
          <ListItemIcon>
            <People />
          </ListItemIcon>
          <ListItemText primary="Médicos" />
        </ListItem>

        <ListItem
          button
          onClick={() => history.push(SynRoutes.listagemPacotesOperacional)}
          id="submenus-pacotes"
        >
          <ListItemIcon style={{ fontSize: '1.4rem' }}>
            <GoPackage />
          </ListItemIcon>
          <ListItemText primary="Pacotes" />
        </ListItem>

        <ListItem
          button
          onClick={() => history.push(SynRoutes.listagemOrcamentosOperacional)}
          id="submenus-solicitacoes-operacional"
        >
          <ListItemIcon>
            <AssignmentOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Solicitações" />
        </ListItem>

        <ListItem
          button
          onClick={() => history.push(SynRoutes.equipamentos)}
          id="submenus-equipamentos"
        >
          <ListItemIcon>
            <FaLaptopMedical />
          </ListItemIcon>
          <ListItemText primary="Equipamentos" />
        </ListItem>

        <ListItem
          button
          onClick={() => history.push(SynRoutes.tarefas)}
          id="submenus-atividades"
        >
          <ListItemIcon style={{ fontSize: '1.3rem' }}>
            <FaTasks />
          </ListItemIcon>
          <ListItemText
            primary={
              <Ubox>
                Atividades{' '}
                {obterQtdePendente() > 0 && (
                  <Chip
                    variant="default"
                    color="secondary"
                    size="small"
                    label={obterQtdePendente()}
                  />
                )}
              </Ubox>
            }
          />
        </ListItem>
        {/* <ListItem
          button
          onClick={() => history.push(SynRoutes.listagemFinanciamentos)}
          id="submenus-financiamentos"
        >
          <ListItemIcon>
            <ChromeReaderMode />
          </ListItemIcon>
          <ListItemText primary="Financiamentos" />
        </ListItem> */}
        <ListItem
          button
          onClick={() => history.push(SynRoutes.listagemParceirosOperacional)}
          id="submenus-parceiros"
        >
          <ListItemIcon>
            <BusinessCenter />
          </ListItemIcon>
          <ListItemText primary="Parceiros" />
        </ListItem>

        <ListItem
          button
          onClick={() => history.push(SynRoutes.historicoAtualizacoes)}
          id="submenus-atualizacoes"
        >
          <ListItemIcon>
            <DynamicFeed />
          </ListItemIcon>
          <ListItemText primary="Atualizações" />
        </ListItem>

        <ListItem
          button
          onClick={() => history.push(SynRoutes.resetSenha)}
          id="submenus-resetar-senha"
        >
          <ListItemIcon>
            <LockOpenOutlined />
          </ListItemIcon>
          <ListItemText primary="Resetar senha" />
        </ListItem>
      </Ubox>
      <ListItem
        button
        onClick={() => history.push(SynRoutes.termos)}
        id="submenus-termos"
      >
        <ListItemIcon>
          <SdCardOutlined />
        </ListItemIcon>
        <ListItemText primary="Termos" />
      </ListItem>

      {(perfilAtual === SynPerfis.TESOURARIA_HOSPITAL ||
        perfilAtual === SynPerfis.ADMIN_HOSPITAL) && (
        <ListItem
          button
          onClick={async () => {
            const code = await gerarAuthCode()
            window.location.href = `${config.baseUrlV2}?code=${code}`
          }}
          id="submenus-financeiro"
        >
          <ListItemIcon style={{ fontSize: '1.4rem' }}>
            <AttachMoneyIcon />
          </ListItemIcon>
          <ListItemText primary="Financeiro" />
        </ListItem>
      )}
    </List>
  )
}

export default menuLateral
